import { render } from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=template&id=2af15b48&scoped=true"
import script from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=script&lang=js"
export * from "./IntentionSetterV1TextEmailSwitch.vue?vue&type=script&lang=js"

import "./IntentionSetterV1TextEmailSwitch.vue?vue&type=style&index=0&id=2af15b48&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af15b48"]])

export default __exports__